<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { checkDeviceType, setMeta } from '@/utils/utils'
import { SET_DEVICE_TYPE } from '@/store/config'
import { mapMutations } from 'vuex'
const device = checkDeviceType()
export default {
  created () {
    if (device === 'mobile') {
      setMeta()
      document.getElementsByTagName('body')[0].setAttribute('id', 'mobile')
      this.setDeviceType('mobile')
    }
    if (this.isIE) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  methods: {
    ...mapMutations({
      setDeviceType: SET_DEVICE_TYPE
    }),
    isIE () {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
  },
  watch: {
    '$route': function (to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/base.scss";
html, body{
    width:100%;
    height:100%;
}
</style>
